var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 17.5V5.83333C6.66666 5.05836 6.66666 4.67087 6.75185 4.35295C6.98302 3.49022 7.65689 2.81635 8.51962 2.58519C8.83753 2.5 9.22502 2.5 10 2.5C10.775 2.5 11.1625 2.5 11.4804 2.58519C12.3431 2.81635 13.017 3.49022 13.2481 4.35295C13.3333 4.67087 13.3333 5.05836 13.3333 5.83333V17.5M4.33333 17.5H15.6667C16.6001 17.5 17.0668 17.5 17.4233 17.3183C17.7369 17.1586 17.9919 16.9036 18.1517 16.59C18.3333 16.2335 18.3333 15.7668 18.3333 14.8333V8.5C18.3333 7.56658 18.3333 7.09987 18.1517 6.74335C17.9919 6.42975 17.7369 6.17478 17.4233 6.01499C17.0668 5.83333 16.6001 5.83333 15.6667 5.83333H4.33333C3.39991 5.83333 2.9332 5.83333 2.57668 6.01499C2.26308 6.17478 2.00811 6.42975 1.84832 6.74335C1.66666 7.09987 1.66666 7.56658 1.66666 8.5V14.8333C1.66666 15.7668 1.66666 16.2335 1.84832 16.59C2.00811 16.9036 2.26308 17.1586 2.57668 17.3183C2.9332 17.5 3.39991 17.5 4.33333 17.5Z",
    stroke: "#7E5AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerBuilding);
export default __webpack_public_path__ + "static/media/career_building.f42f82469f773e84887c4e6df9cf9158.svg";
export { ForwardRef as ReactComponent };